import { User } from "../../auth/User";
import StorageUtils from "../../ui/StorageUtils";
import ApiUrl from "../ApiUrl";
import authService from "../AuthServicev2";
import AdayIdxRootservice from "../Ebasvuru/AdayDomain/AdayIdxRootService";
import EbasvuruTenantservice from "../Ebasvuru/EbasvuruTenantService";
import Moduleservice from "../GeneralServices/ModuleService";
import KullaniciRolleriservice from "../IKIseAlimServices/KullaniciRolleriService";
import MasterUserservice from "../MasterServices/MasterUserService";

class AccountService {


    constructor() {
        this.user = new User();
    }

    async login(username, password) {

        const result = await authService.login(username, password);

        if (!result) {
            return {
                isSuccess: false,
                message: "message.invalidUsernameOrPassword"
            }
        }

        this.user.masterToken = result.token;

        const sysMasterRes = await MasterUserservice.get({ username: username, masterUserTipi: 1 }, result.token);

        if (sysMasterRes.isSuccess && sysMasterRes.isSuccess && sysMasterRes.resultCount > 0) {
            this.user.adSoyad = sysMasterRes.fullName ?? username;
            this.user.accessToken = result.token;
            this.user.isMaster = true;
            this.user.loginType = "admin";
            return {
                isSuccess: true,
                isMaster: true,
                masteruser: this.user
            }
        }



        const tenant = await authService.getAuthorizedTenants(this.user.masterToken);

        return {
            isSuccess: true,
            tenant: tenant,
            isMaster: false
        };

    }

    async loginAsTenant(tenant) {

        try {

            const result = await authService.login4Tenant(tenant.masterTenant.guid, this.user.masterToken);

            if (!result.token) {
                return {
                    isSuccess: false,
                    message: "message.login4TenantIssue"
                }
            }

            const userResponse = await authService.getbyToken(result.token);

            if (!userResponse) {
                return {
                    isSuccess: false,
                    message: "message.getUserInfoIssue"
                }
            }

            var sgkRol = await KullaniciRolleriservice.get({ rolSistem: "SGK", kullaniciId: userResponse.id }, result.token);

            if (!(sgkRol.isSuccess && sgkRol.resultObject && sgkRol.resultObject.length > 0)) {
                return {
                    isSuccess: false,
                    message: " message.SgkRolMandatory"
                };
            }

            this.user.accessToken = result.token;
            this.user.isMaster = false;
            this.user.tenantName = tenant.masterTenant.name;
            this.user.tenantIcon = tenant.masterTenant.iconUrl;
            this.user.id = userResponse.id;
            this.user.loginType = "tenant";
            this.user.adSoyad = userResponse.adSoyad;

            var res = await Moduleservice.get({ isSysDefault: true }, this.user.accessToken);
            let pageurl = "/";
            if (res && res.isSuccess && res?.resultObject[0]?.yol) {
                pageurl = res?.resultObject[0]?.yol;
            }



            return {
                isSuccess: true,
                pageurl: pageurl,
                user: this.user
            };
        } catch (e) {

            return {
                isSuccess: false,
                message: "message.faildToLogin",
                detail: e
            };
        }

    }

    async loginWithSession(sessionKey) {

        const result = await authService.loginSessionKey(sessionKey);
        if (!result) {
            return {
                isSuccess: false,
                message: "message.invalidUsernameOrPassword"
            }
        }

        this.user.masterToken = result.token;
        const tenant = await authService.getAuthorizedTenants(this.user.masterToken);

        return {
            isSuccess: true,
            tenant: tenant,
            isMaster: false
        };

    }
    async loginAsAday({ tenant }) {

        const result = await authService.easyPost(ApiUrl.auth.createUITenantToken, {
            kod: tenant
        });

        const masterTenant = await authService.fullPathPost(
            ApiUrl.auth.getPublicTenantByToken,
            {},
            result.resultObject.token
        );

        return {
            token: result.resultObject.token,
            masterTenant: masterTenant.resultObject,
        }
    }

    async loginAsAdayByCode(data, token) {

        //  EbasvuruTenantservice.setToken(token);
        var result = await EbasvuruTenantservice.fullPathPost(ApiUrl.publicEndpoint.OnayKoduGiris, data, token);
        if (result && result.resultObject && result.resultObject.authorized == true) {

            return {
                isSuccess: true,
                token: result.resultObject.token,
                data: result.resultObject,
                user: StorageUtils.get("aday")
            }
        } else {

            return {
                isSuccess: false,
            }
        }
    }

    async loginWithSession(sessionKey) {

        const result = await authService.loginSessionKey(sessionKey);
        if (!result) {
            return {
                isSuccess: false,
                message: "message.invalidUsernameOrPassword"
            }
        }

        this.user.masterToken = result.token;
        const tenant = await authService.getAuthorizedTenants(this.user.masterToken);

        return {
            isSuccess: true,
            tenant: tenant,
            isMaster: false
        };

    }

}

const Accountservice = new AccountService();

export default Accountservice;